import { render, staticRenderFns } from "./checkboxRemote.vue?vue&type=template&id=f3010684"
import script from "./checkboxRemote.vue?vue&type=script&lang=js"
export * from "./checkboxRemote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5cxdem7bu5cwsxatf4y6tpyoxu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports